import { Type } from '@angular/core';
import { DriveCycleTable } from './tables/drive-cycle/drive-cycle.table';
import { DriveCycleTableMenu } from './tables/drive-cycle/menu/drive-cycle-table.menu';

export const awfContributionOverrides = (): Type<unknown>[] => [
  DriveCycleTable,
  DriveCycleTableMenu,
];
